






















































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import RencanaAsuhanTerintegrasiSvc from "@/services/RencanaAsuhanTerintegrasi";
import {
  BarisRencanaTerintegrasi,
  ButirIntervensi,
  ButirMasalah,
  ButirSasaran,
  KolomPpa,
  RencanaAsuhanTerintegrasi
} from "@/types/rencanaAsuhanTerintegrasi";

const WARNA_PPA: Record<KolomPpa, { kepala: string; sel: string; titik: string }> = {
  dokter: { kepala: "#bbdefb", sel: "#f4f9ff", titik: "#1e88e5" },
  perawat: { kepala: "#c8e6c9", sel: "#f4fbf5", titik: "#43a047" },
  gizi: { kepala: "#ffe082", sel: "#fffbea", titik: "#f9a825" },
  farmasi: { kepala: "#d1c4e9", sel: "#f8f5fd", titik: "#7e57c2" },
  lain: { kepala: "#e0e0e0", sel: "#fafafa", titik: "#757575" }
};

const LABEL_PPA: Record<KolomPpa, string> = {
  dokter: "Dokter",
  perawat: "Perawat",
  gizi: "Gizi",
  farmasi: "Farmasi",
  lain: "PPA Lain"
};

// Teks elemen penilaian dikutip dari KMK HK.01.07/MENKES/1596/2024 hlm. 266–267.
const EP_PAP_12: Record<string, string> = {
  a:
    "PPA telah membuat rencana asuhan untuk setiap pasien setelah diterima sebagai pasien rawat inap dalam waktu 24 jam berdasarkan hasil pengkajian awal.",
  b:
    "Rencana asuhan dievaluasi secara berkala, direvisi atau dimutakhirkan serta didokumentasikan dalam rekam medis oleh setiap PPA.",
  c:
    "Instruksi berdasarkan rencana asuhan dibuat oleh PPA yang kompeten dan berwenang, dengan cara yang seragam, dan didokumentasikan di CPPT.",
  d:
    "Rencana asuhan pasien dibuat dengan membuat sasaran yang terukur dan di dokumentasikan.",
  e:
    "DPJP telah melakukan evaluasi/review berkala dan verifikasi harian untuk memantau terlaksananya asuhan secara terintegrasi dan membuat notasi sesuai dengan kebutuhan."
};

interface ChipIndikator {
  teks: string;
  warna: string;
}

interface Indikator {
  kode: string;
  judul: string;
  ep: string;
  status: "ok" | "warn" | "none";
  nilai?: string;
  chips?: ChipIndikator[];
}

@Component
export default class RencanaAsuhanTerintegrasiV2 extends Vue {
  @Prop({ type: [Number, String], default: null }) readonly register!:
    | number
    | string
    | null;
  @Prop({ type: Boolean, default: false }) readonly isActive!: boolean;

  hasil: RencanaAsuhanTerintegrasi | null = null;
  registerHasil: number | string | null = null;
  loading = false;
  gagal = false;
  permintaanKe = 0;
  sembunyikanSelesai = false;
  riwayatTerbuka: Record<string, boolean> = {};
  dialogSumber = false;
  barisSumber: BarisRencanaTerintegrasi | null = null;

  @Watch("isActive", { immediate: true })
  onAktif(val: boolean) {
    if (val && this.registerHasil !== this.register) {
      this.muat();
    }
  }

  @Watch("register")
  onRegister() {
    this.permintaanKe++;
    this.hasil = null;
    this.registerHasil = null;
    this.riwayatTerbuka = {};
    this.loading = false;
    if (this.isActive) {
      this.muat();
    }
  }

  async muat() {
    if (!this.register) return;
    const nomor = ++this.permintaanKe;
    const register = this.register;
    this.loading = true;
    this.gagal = false;
    try {
      const hasil = await RencanaAsuhanTerintegrasiSvc.getByRegister(register);
      if (nomor !== this.permintaanKe || register !== this.register) return;
      this.hasil = hasil;
      this.registerHasil = register;
    } catch (e) {
      if (nomor === this.permintaanKe) this.gagal = true;
    } finally {
      if (nomor === this.permintaanKe) this.loading = false;
    }
  }

  get barisTampil() {
    const daftar = this.hasil ? this.hasil.masalah : [];
    return daftar
      .filter(b => !this.sembunyikanSelesai || b.status === "aktif")
      .map((b, i) => ({
        ...b,
        no: i + 1,
        warnaBar: this.warnaBar(b),
        masalahLain: b.masalah.slice(1),
        asal: this.asalMasalah(b.masalah),
        dataRingkas: this.ringkasData(b),
        sasaranGrup: this.kelompokkanSasaran(b.sasaran),
        dokterGrup: this.kelompokkanDokter(b.intervensi.dokter || []),
        statusSasaran: this.statusSasaran(b),
        statusEvaluasi: this.statusEvaluasi(b)
      }));
  }

  get indikator(): Indikator[] {
    if (!this.hasil) return [];
    const ind = this.hasil.indikator_pap;
    const b = ind.b_evaluasi_revisi;
    const c = ind.c_instruksi_cppt;
    const d = ind.d_sasaran_terukur;
    const e = ind.e_dpjp;

    return [
      {
        kode: "a",
        judul: "Rencana awal ≤ 24 jam",
        ep: EP_PAP_12.a,
        status: ind.a_rencana_24_jam.every(r => r.dalam_24_jam !== false)
          ? "ok"
          : "warn",
        chips: ind.a_rencana_24_jam.map(r => ({
          teks:
            LABEL_PPA[r.ppa] +
            (r.jam_sejak_masuk === null
              ? " —"
              : " " + this.formatJam(r.jam_sejak_masuk)),
          warna:
            r.dalam_24_jam === null
              ? "grey lighten-3"
              : r.dalam_24_jam
              ? "green lighten-4"
              : "red lighten-4"
        }))
      },
      {
        kode: "b",
        judul: "Evaluasi & pemutakhiran",
        ep: EP_PAP_12.b,
        status: this.statusRasio(b.dievaluasi, b.masalah_aktif),
        nilai: `${b.dievaluasi} dari ${b.masalah_aktif} masalah sudah dievaluasi/dimutakhirkan`
      },
      {
        kode: "c",
        judul: "Instruksi di CPPT",
        ep: EP_PAP_12.c,
        status: c.cppt_dokter === 0 ? "none" : c.dengan_instruksi ? "ok" : "warn",
        nilai: `${c.dengan_instruksi} dari ${c.cppt_dokter} CPPT dokter memuat kolom instruksi`
      },
      {
        kode: "d",
        judul: "Sasaran terukur",
        ep: EP_PAP_12.d,
        status: this.statusRasio(d.bersasaran, d.masalah_aktif),
        nilai: `${d.bersasaran} dari ${d.masalah_aktif} masalah bersasaran · ${d.sasaran_lintas_ppa} sasaran lintas PPA`
      },
      {
        kode: "e",
        judul: "Review & verifikasi DPJP",
        ep: EP_PAP_12.e,
        status: this.statusRasio(e.terverifikasi, e.perlu_verifikasi),
        nilai:
          `CPPT DPJP terakhir ${this.formatWaktu(e.cppt_dpjp_terakhir)} · ` +
          `${e.terverifikasi}/${e.perlu_verifikasi} catatan PPA terverifikasi`
      }
    ];
  }

  get namaRaber() {
    return this.hasil
      ? this.hasil.tim.raber.map(r => r.nama || "-").join(", ")
      : "";
  }

  get bagianSumber() {
    const b = this.barisSumber;
    if (!b) return [];
    const intervensi = (Object.keys(b.intervensi) as KolomPpa[]).reduce(
      (acc, k) => acc.concat(b.intervensi[k] || []),
      [] as ButirIntervensi[]
    );
    return [
      { judul: "Masalah", butir: b.masalah },
      { judul: "Data pendukung", butir: b.data },
      { judul: "Sasaran", butir: b.sasaran },
      { judul: "Intervensi", butir: intervensi },
      { judul: "Evaluasi", butir: b.evaluasi },
      {
        judul: "Riwayat pemutakhiran",
        butir: b.riwayat.map(r => ({
          teks: r.peristiwa,
          ppa: r.ppa,
          oleh: r.oleh,
          waktu: r.waktu,
          sumber: "Riwayat"
        }))
      }
    ];
  }

  statusRasio(pembilang: number, penyebut: number): "ok" | "warn" | "none" {
    if (!penyebut) return "none";
    return pembilang >= penyebut ? "ok" : "warn";
  }

  warnaBar(b: BarisRencanaTerintegrasi) {
    if (b.tanpa_masalah) return "kosong";
    if (b.status === "teratasi") return "teratasi";
    if (b.status === "lampau") return "lampau";
    return b.jenis === "risiko" ? "risiko" : "aktual";
  }

  asalMasalah(masalah: ButirMasalah[]) {
    const label: string[] = [];
    masalah
      .filter(m => m.status !== "lampau")
      .forEach(m => {
        let teks = m.sumber;
        if (m.sumber.indexOf("Rencana askep") === 0) teks = "rencana askep perawat";
        else if (m.sumber === "ADIME") teks = "ADIME gizi";
        else if (m.sumber === "CPPT SOAP")
          teks = "CPPT " + LABEL_PPA[m.ppa].toLowerCase();
        else if (m.sumber.indexOf("Catatan Edukasi") === 0)
          teks = "catatan edukasi";
        if (label.indexOf(teks) === -1) label.push(teks);
      });
    return label.length ? label.join(" & ") : "asesmen sebelumnya";
  }

  ringkasData(b: BarisRencanaTerintegrasi) {
    const teks = b.data.slice(0, 6).map(d => d.teks);
    const sisa = b.data.length - teks.length;
    return teks.join("; ") + (sisa > 0 ? ` (+${sisa} lainnya)` : "");
  }

  kelompokkanSasaran(sasaran: ButirSasaran[]) {
    const grup: { kerangka: string | null; butir: ButirSasaran[] }[] = [];
    sasaran.forEach(s => {
      const kerangka = s.kerangka_waktu || null;
      let g = grup.find(x => x.kerangka === kerangka);
      if (!g) {
        g = { kerangka, butir: [] };
        grup.push(g);
      }
      g.butir.push(s);
    });
    return grup.slice().sort((a, b) => (a.kerangka ? 0 : 1) - (b.kerangka ? 0 : 1));
  }

  kelompokkanDokter(daftar: ButirIntervensi[]) {
    const grup: { judul: string; butir: ButirIntervensi[] }[] = [];
    daftar.forEach(it => {
      const judul = it.oleh
        ? it.oleh + (it.keterangan ? ` (${it.keterangan})` : "")
        : "Rencana edukasi / pulang";
      let g = grup.find(x => x.judul === judul);
      if (!g) {
        g = { judul, butir: [] };
        grup.push(g);
      }
      g.butir.push(it);
    });
    return grup;
  }

  statusSasaran(b: BarisRencanaTerintegrasi): ChipIndikator | null {
    if (b.tanpa_masalah || b.status !== "aktif") return null;
    if (!b.sasaran.length)
      return { teks: "Belum ada sasaran terukur", warna: "red lighten-4" };
    if (b.ppa_sasaran.length >= 2)
      return {
        teks: `Sasaran tim · ${b.ppa_sasaran.length} PPA`,
        warna: "green lighten-4"
      };
    if (b.ppa_terlibat.length >= 2)
      return { teks: "Sasaran baru dari 1 PPA", warna: "amber lighten-4" };
    return { teks: "Sasaran 1 PPA", warna: "grey lighten-3" };
  }

  statusEvaluasi(b: BarisRencanaTerintegrasi): ChipIndikator {
    if (b.status === "teratasi") return { teks: "Teratasi", warna: "green lighten-4" };
    if (b.status === "lampau")
      return { teks: "Tidak tercantum lagi", warna: "grey lighten-3" };
    if (b.evaluasi.length || b.riwayat.length > 1)
      return { teks: "Aktif · sudah dievaluasi", warna: "blue lighten-4" };
    return { teks: "Aktif · belum ada evaluasi", warna: "amber lighten-4" };
  }

  toggleRiwayat(kunci: string) {
    this.$set(this.riwayatTerbuka, kunci, !this.riwayatTerbuka[kunci]);
  }

  bukaSumber(b: BarisRencanaTerintegrasi) {
    this.barisSumber = b;
    this.dialogSumber = true;
  }

  warnaPpa(k: KolomPpa) {
    return WARNA_PPA[k] || WARNA_PPA.lain;
  }

  titikPpa(k: KolomPpa) {
    return { background: this.warnaPpa(k).titik };
  }

  labelPpa(k: KolomPpa) {
    return LABEL_PPA[k] || k;
  }

  labelJenis(jenis: string) {
    return jenis === "instruksi" ? "Instruksi" : jenis === "edukasi" ? "Edukasi" : "";
  }

  formatJam(jam: number) {
    return jam < 0 ? "sebelum masuk" : `${jam} jam`;
  }

  formatWaktu(waktu: string | null, lengkap = false) {
    if (!waktu) return "-";
    const m = moment(waktu);
    if (!m.isValid()) return "-";
    return m.format(lengkap ? "DD/MM/YYYY HH:mm" : "DD/MM HH:mm");
  }
}
